import { Action } from '~/authorizations';
import Can from '~/authorizations/Can';
import Menu from './Menu';
import Objects from './Objects/';

export default function TopLeftSection() {
  return (
    <Can action={Action.EditCivilDraw}>
      <div className="left-4 top-4 flex gap-2">
        <Menu />
        <Objects />
      </div>
    </Can>
  );
}
